import "./abstract-base-xBS_db8B.js";
import { e as b } from "./query-Dk6NwgU8.js";
import { r as y } from "./query-all-C6Qf4al2.js";
const f = ({
  finisher: e,
  descriptor: a
}) => (
  // eslint-disable-next-line consistent-return
  (t, o) => {
    var n;
    if (o !== void 0) {
      const l = t.constructor;
      a !== void 0 && Object.defineProperty(t, o, a(o)), e == null || e(l, o);
    } else {
      const l = (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (n = t.originalKey) != null ? n : t.key
      ), r = a !== void 0 ? {
        kind: "method",
        placement: "prototype",
        key: l,
        descriptor: a(t.key)
      } : { ...t, key: l };
      return e && (r.finisher = function(s) {
        e(s, l);
      }), r;
    }
  }
);
function c(e, a, t = {}, o = !1) {
  var r;
  const n = `slot${a ? `[name=${a}]` : ":not([name])"}`, l = (r = e.renderRoot) == null ? void 0 : r.querySelector(n);
  return l ? o ? l.assignedNodes(t).filter((s) => s.nodeType !== Node.COMMENT_NODE) : l.assignedElements(t) : [];
}
function g(e) {
  return typeof e == "string" ? { version: e } : e.alternateSlot !== void 0 && e.alternateSlot !== null ? { alternateSlot: e.alternateSlot, version: e.version } : { alternateAttribute: e.alternateAttribute, version: e.version };
}
function h(e, a = !1) {
  const { slot: t, selector: o, deprecated: n, flatten: l } = e != null ? e : {};
  let r;
  return n && (r = g(n)), f({
    descriptor: (s) => ({
      get() {
        let u = c(this, t, { flatten: l });
        return u.length === 0 && n && r && r.alternateSlot && (u = c(this, r.alternateSlot, { flatten: l })), o ? u == null ? void 0 : u.filter((i) => {
          var m;
          return a ? ((m = i == null ? void 0 : i.nodeName) == null ? void 0 : m.toLowerCase()) === this.getScopedTagName(o) : i.matches(o);
        }) : u;
      },
      set(u) {
        if (n) {
          const i = t != null ? t : "";
          this.alternateSlots.set(i, r);
        }
      },
      enumerable: !0,
      configurable: !0
    })
  });
}
function N(e) {
  return function(a, t) {
    return b(e)(a, t);
  };
}
function C(e, a) {
  return f({
    descriptor: (t) => ({
      get() {
        var n;
        return (n = this.querySelector(e)) != null ? n : null;
      },
      enumerable: !0,
      configurable: !0
    })
  });
}
function A({ slot: e, defaultValue: a }) {
  return f({
    descriptor: (t) => ({
      get() {
        var l, r, s;
        const n = c(this, e)[0];
        return (s = (r = (l = n == null ? void 0 : n.textContent) == null ? void 0 : l.trim()) != null ? r : a) != null ? s : "";
      },
      enumerable: !0,
      configurable: !0
    })
  });
}
function E(e) {
  return function(a, t) {
    return y(e)(a, t);
  };
}
function k(e, a = !1) {
  const { slot: t, selector: o, deprecated: n, flatten: l } = e != null ? e : {};
  let r;
  return n && (r = g(n)), f({
    descriptor: (s) => ({
      get() {
        let u = c(this, t, { flatten: l }, !0);
        return u.length === 0 && n && r && r.alternateSlot && (u = c(this, r.alternateSlot, { flatten: l }, !0)), u;
      },
      set(u) {
        if (n) {
          const i = t != null ? t : "";
          this.alternateSlots.set(i, r);
        }
      },
      enumerable: !0,
      configurable: !0
    })
  });
}
export {
  h as a,
  N as b,
  E as c,
  k as d,
  C as q,
  A as s
};
